const api = "https://api.vishu-singla.com";

export default api;
